/**
 * Shared constants for change type visual treatment.
 *
 * EntityChange uses lowercase change_type values: created, updated, deleted, ignored.
 */

import type { BadgeColor } from '@/components/ui/catalyst/badge';
import type { EntityChangeType } from '@/services/api/generated/entityChangesService';

export const CHANGE_TYPE_CONFIG: Record<
  EntityChangeType,
  { label: string; color: BadgeColor }
> = {
  created: { label: 'Created', color: 'orange' },
  updated: { label: 'Updated', color: 'blue' },
  deleted: { label: 'Deleted', color: 'red' },
  ignored: { label: 'Ignored', color: 'zinc' },
};

export const CHANGE_TYPE_BORDER: Record<EntityChangeType, string> = {
  created: 'border-l-orange-400',
  updated: 'border-l-blue-400',
  deleted: 'border-l-red-400',
  ignored: '',
};

export const CHANGE_TYPE_ORDER: Record<EntityChangeType, number> = {
  created: 0,
  updated: 1,
  deleted: 2,
  ignored: 3,
};
